import { analyticsTrackEvent } from '../../utils/analytics';
import { MATERIALS_DELETE_SECTION } from '../../constants/analytics';
import { DeleteSectionContract } from '@ublend-npm/aula-schema/types/materials';
import { CLASSROOM_MATERIAL_SECTION } from '../../constants/endpoints';
import request from './request';

const deleteSection = async (
  classRoomId: string,
  sectionId: string,
  correlationId?: string,
  educatorOnly?: boolean,
  isRbacEnabled?: boolean
) => {
  const url = CLASSROOM_MATERIAL_SECTION(classRoomId, sectionId, educatorOnly);
  const response = await request<DeleteSectionContract>({
    method: 'delete',
    url,
  });
  if (response.status === 204) {
    try {
      analyticsTrackEvent(MATERIALS_DELETE_SECTION, {
        itemId: sectionId,
        spaceId: classRoomId,
        itemType: 'Material',
        isRbacEnabled,
      });
    } catch {
      // Analytics must not turn a successful API request into a failed action.
    }
  }
  return response.status === 204;
};

export default deleteSection;
